import { AutocompleteResponseItem } from '../../queries/woosmap/address-queries';
import { WoosmapType } from '../../types/commons';

/**
 * Used to hide addresses without number (type route) and show only addresses
 * with number (type address).
 */
type FilterWoosmapSuggestionsProps = {
  suggestions: AutocompleteResponseItem[] | undefined;
  excludedTypes: WoosmapType[];
};

const isExcluded = (suggestion: AutocompleteResponseItem, excludedTypes: WoosmapType[]) =>
  !suggestion?.types.some((type) => excludedTypes.includes(type));

/**
 * Used to hide addresses without number (type route) and show only addresses
 * with number (type address).
 */
export const filterWoosmapSuggestions = ({
  suggestions,
  excludedTypes,
}: FilterWoosmapSuggestionsProps): AutocompleteResponseItem[] | undefined =>
  excludedTypes.length ? suggestions?.filter((suggestion) => isExcluded(suggestion, excludedTypes)) : suggestions;
